export default __webpack_public_path__ + "static/6)Undefined-6c5201bef3e9467277d44865ecfb4b7b.mp3";